import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { MenuItem, MessageService } from 'primeng/api';

@Component({
  selector: 'language-switch',
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss']
})
export class LanguageSwitchComponent implements OnInit {
  items: MenuItem[];
  activeLang: string;

  constructor(
    private translocoService: TranslocoService
  ) {
    this.activeLang = this.translocoService.getActiveLang();
  }

  ngOnInit(): void {
    // Subscribe to language changes
    this.translocoService.langChanges$.subscribe((activeLang) => {
      // Get the active lang
      this.activeLang = activeLang;
    });

    this.items = [
      {
        icon: 'language-flag it-flag',
        command: () => {
          this._setActiveLang('it');
        }
      },
      {
        icon: 'language-flag en-flag',
        command: () => {
          this._setActiveLang('en');
        }
      }
    ];
  }

  _setActiveLang(lang: string) {
    localStorage.setItem('lang', lang);
    this.translocoService.setActiveLang(lang);
  }
}


